import clsx from "clsx";
import { format } from "date-fns";

import { TransactionModel } from "@interfaces/index";
import { formatAmount } from "@utils/index";
import {
  TransactionStatus,
  FileDescriptionSvg,
  AssetItem,
  AlertTriangleSvg,
} from "@components/index";

export const TableTdMobileTransaction = ({
  transaction,
  hideAssetColumn,
  onClickRow,
}: {
  transaction: TransactionModel;
  hideAssetColumn: boolean;
  onClickRow?: () => void;
}) => {
  const files = transaction.attachments?.length || 0;

  return (
    <tr onClick={onClickRow} data-testid="tr_transactionTable">
      <td className="rounded-lg border border-black-8 pb-4 pt-2.5">
        <div className="flex items-center justify-between px-4">
          <div className="text-black-54">
            {format(new Date(transaction.date), "dd.MM.yyyy")}
          </div>
          <TransactionStatus status={transaction.status} />
        </div>
        {!hideAssetColumn && transaction.asset && (
          <div className="px-4">
            <AssetItem
              type={transaction.asset.type}
              name={transaction.asset.name}
            />
            {transaction.asset.uploadLaterAgreement ||
            transaction.asset.uploadLaterInvoice ? (
              <div className="mt-1 flex items-center text-100 text-black-70 *:mr-1 *:size-4">
                <AlertTriangleSvg />
                Documents required
              </div>
            ) : null}
          </div>
        )}
        <div className="flex px-4 pt-2">
          <div className="font-bold capitalize text-black-100">
            {transaction.type}
            {transaction.refund && (
              <span className="text-100 font-normal text-black-54">
                {" "}
                • Refund
              </span>
            )}
          </div>
          {!!files && (
            <div className="flex pl-1 text-primary-300 *:size-[18px]">
              <FileDescriptionSvg />
              {files}
            </div>
          )}
        </div>
        <div className="mt-2 flex flex-col gap-y-0.5 px-4">
          <div className="text-black-100">
            Transaction Source: {transaction.isImported ? "Imported" : "FBTC"}
          </div>
          {transaction.isImported && (
            <div
              className="flex w-fit rounded-md bg-green-100 px-2 text-white-100"
              title="Imported transaction category in external system"
            >
              {transaction.externalCategoryTitle || "Unmapped Category"}
            </div>
          )}
          <div className="text-black-54">
            {transaction.category.title} | {transaction.subcategory.title}
          </div>
        </div>
        <div
          className={clsx(
            "flex items-center gap-x-2 px-4 pt-4 text-300 font-bold",
            transaction.type === "income" ? "text-green-100" : "text-black-100",
          )}
        >
          {formatAmount(transaction.amount)}
          {transaction.disallowed && (
            <div className="border-l pl-2 text-100 font-light text-black-54">
              This is a disallowed transaction and will not be included in your
              calculations.
            </div>
          )}
        </div>
        {transaction.description && (
          <div className="mt-6 border-t border-t-black-8 px-4 pt-4 text-black-70">
            <div className="pb-2.5 text-black-54">Description</div>
            <div>{transaction.description}</div>
          </div>
        )}
      </td>
    </tr>
  );
};
